import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, setLanguage, type Language } from '../../lib/i18n'
import { prefsApi } from '../../lib/api'

// LanguageSwitcher — switches the UI language instantly (i18n) and persists the choice
// to the user's `language` preference so it follows them across devices/sessions.
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  const current = (i18n.language || 'en').split('-')[0] as Language

  function choose(lang: Language) {
    if (lang === current) return
    setLanguage(lang)            // instant UI switch + localStorage
    prefsApi.update({ language: lang }).catch(() => { /* best-effort persist */ })
  }

  return (
    <div role="group" aria-label={t('settings.language')} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {SUPPORTED_LANGUAGES.map(lang => {
        const active = lang === current
        return (
          <button
            key={lang}
            onClick={() => choose(lang)}
            aria-pressed={active}
            style={{
              padding: '8px 16px',
              borderRadius: 8,
              minHeight: 40,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: active ? 700 : 500,
              border: `1px solid ${active ? 'var(--color-primary, #F5A623)' : 'var(--color-border, #2a3320)'}`,
              background: active ? 'color-mix(in srgb, var(--color-primary, #F5A623) 16%, transparent)' : 'transparent',
              color: active ? 'var(--color-primary, #F5A623)' : 'var(--color-text-primary)',
            }}
          >
            {t('language.' + lang)}
          </button>
        )
      })}
    </div>
  )
}
